module.exports = __webpack_public_path__ + "static/media/combat(1).396da2d3.PNG";